import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif", // Default font for all MUI components
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingTop: 0, // Removes padding from the top of the menu list globally
          paddingBottom: 0, // Removes padding from the top of the menu list globally
        },
      },
    },
  },
  palette: {
    mode: "light",
  },
});

const darkTheme = createTheme({
  typography: {
    fontFamily: "Inter, sans-serif", // Default font for all MUI components
  },
  components: {
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingTop: 0, // Removes padding from the top of the menu list globally
          paddingBottom: 0, // Removes padding from the top of the menu list globally
        },
      },
    },
  },
  palette: {
    mode: "dark",
  },
});

export { lightTheme, darkTheme };
